var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('img',{attrs:{"src":require("./../../assets/image/logo.png"),"mode":"aspectFill"}}),_c('p',[_vm._v(_vm._s(_vm.doorName))]),_c('p',[_vm._v("1.0.0")]),_c('p',[_vm._v("成都元素科技有限公司技术支持")])])}
var staticRenderFns = []

export { render, staticRenderFns }